import React, { useContext, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import VistaParticipacion from "../vistas/VistaParticipacion";
import FormParticipacion from "../formularios/FormParticipacion";
// Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ConfirmModalContext } from "../../../context/confirmModalContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";

const Participacion = ({ idProvincia, idComunidad, participacion, deleteParticipacionState, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);
  // UEF para guardar los datos de la participacion
  const [datosParticipacion, setDatosParticipacion] = useState(participacion);

  // Edita una participacion de una comunidad
  const putDatosParticipacion = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}/participaciones/${datosParticipacion.id}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Elimina una participación de una comunidad
  const deleteDatosParticipacion = () => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}/participaciones/${datosParticipacion.id}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador para el put de los datos de las participaciones de la comunidad
  const handlePutDatosParticipacion = (data) => {
    setLoading(true);
    modalSetShow(false);
    // Hacemos el put para los datos de las participaciones
    putDatosParticipacion(data)
      .then((response) => {
        setDatosParticipacion(response);
        addAlert("Exito", "Se ha editado correctamente la participación", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el delete de los datos de las participaciones de la comunidad
  const handleDeleteDatosParticipacion = (data) => {
    setLoading(true);
    modalSetShow(false);
    // Hacemos el delete para los datos de las participaciones
    deleteDatosParticipacion(data)
      .then((response) => {
        deleteParticipacionState(data.id);
        addAlert("Exito", "Se ha eliminado correctamente la participación", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />

      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              {datosParticipacion?.type}
            </Accordion.Toggle>
            <Button
              onClick={() => {
                confirmModalSetTitle(`Eliminar participación en ${participacion.type}`);
                confirmModalSetContent(<p> {"¿Está seguro de que quiere eliminarla?"} </p>);
                confirmModalSetFunction(() => {
                  handleDeleteDatosParticipacion(datosParticipacion);
                });
                confirmModalSetShow(true);
              }}
              variant="outline-danger"
              size="sm"
              className="float-right mr-4"
            >
              Eliminar
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar participación");
                modalSetContent(<FormParticipacion defaultValues={datosParticipacion} submissionHandler={handlePutDatosParticipacion} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaParticipacion datosParticipacion={datosParticipacion} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Participacion;
